import { jsx } from 'react/jsx-runtime';

const SvgCross = (props) => /* @__PURE__ */ jsx("svg", {
  width: "1em",
  height: "1em",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /* @__PURE__ */ jsx("path", {
    d: "m9.206 8.5 2.646-2.647a.5.5 0 0 0-.707-.707L8.5 7.792 5.853 5.146a.5.5 0 0 0-.707.707L7.792 8.5l-2.646 2.646a.5.5 0 0 0 .708.707L8.5 9.206l2.646 2.646a.498.498 0 0 0 .708 0 .5.5 0 0 0 0-.707L9.206 8.5Z",
    fill: "#445058"
  })
});

export { SvgCross as default };
//# sourceMappingURL=Cross.js.map
